// extracted by mini-css-extract-plugin
export default {"main":"blogs_main__vmvQA","blog":"blogs_blog__OGsky","left":"blogs_left__sZorv"};